import React, { useRef } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import addPlayer from './store/actions';
import CreatePlayerForm from './CreatePlayerForm';
import createPlayerSchema from './validationSchema';
import Loader from '../../shared/displayComponents/loader/Loader';

const cleanCustom = values => values.map(value => value.trim()).filter(Boolean);

const CreatePlayer = () => {
  const { isLoading } = useSelector(({ shared }) => shared);
  const multiselectEnglishRef = useRef();
  const multiselectPhysicalsRef = useRef();
  const multiselectAnalysisRef = useRef();
  const multiSelectLevelOfPlayRef = useRef();
  const positionRef = useRef();

  const { register, handleSubmit, errors, watch, control } = useForm({
    validationSchema: createPlayerSchema,
    defaultValues: {
      sport: 'Volleyball',
      hidden: false,
      transfer: false,
    },
  });
  const { fields, append, prepend, remove } = useFieldArray({
    control,
    name: 'youtubeUrl',
  });

  const {
    fields: accomplishmentsFields,
    append: accomplishmentsAppend,
    remove: accomplishmentsRemove,
  } = useFieldArray({
    control,
    name: 'accomplishments',
  });

  const {
    fields: customPhysicalsFields,
    append: customPhysicalsAppend,
    remove: customPhysicalsRemove,
  } = useFieldArray({
    control,
    name: 'customPhysicals',
  });

  const {
    fields: customAnalysisFields,
    append: customAnalysisAppend,
    remove: customAnalysisRemove,
  } = useFieldArray({
    control,
    name: 'customAnalysis',
  });

  const dispatch = useDispatch();
  const history = useHistory();
  const selectedSport = watch('sport');
  const isTransfer = watch('transfer');

  const createPlayer = ({
    image,
    customPhysicals = [],
    customAnalysis = [],
    ...player
  }) => {
    const analysis = multiselectAnalysisRef.current.getSelectedItems();
    const physicals = multiselectPhysicalsRef.current.getSelectedItems();
    const englishSkills = multiselectEnglishRef.current.getSelectedItems();
    const levelOfPlay = multiSelectLevelOfPlayRef.current.getSelectedItems();
    const position = positionRef.current.getSelectedItems();
    const formData = {
      formValues: {
        ...player,
        englishSkills,
        physicals: [
          ...physicals.map(({ key }) => key),
          ...cleanCustom(customPhysicals),
        ],
        analysis: [...analysis, ...cleanCustom(customAnalysis)],
        levelOfPlay,
        position,
      },
      files: image,
    };
    dispatch(addPlayer(formData, history));
  };

  return isLoading ? (
    <Loader />
  ) : (
    <CreatePlayerForm
      fields={fields}
      append={append}
      prepend={prepend}
      remove={remove}
      multiselectAnalysisRef={multiselectAnalysisRef}
      multiselectPhysicalsRef={multiselectPhysicalsRef}
      multiselectEnglishRef={multiselectEnglishRef}
      multiSelectLevelOfPlayRef={multiSelectLevelOfPlayRef}
      selectedSport={selectedSport}
      isTransfer={isTransfer}
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      createPlayer={createPlayer}
      accomplishmentsFields={accomplishmentsFields}
      accomplishmentsAppend={accomplishmentsAppend}
      accomplishmentsRemove={accomplishmentsRemove}
      customPhysicalsFields={customPhysicalsFields}
      customPhysicalsAppend={customPhysicalsAppend}
      customPhysicalsRemove={customPhysicalsRemove}
      customAnalysisFields={customAnalysisFields}
      customAnalysisAppend={customAnalysisAppend}
      customAnalysisRemove={customAnalysisRemove}
      positionRef={positionRef}
    />
  );
};

export default CreatePlayer;
